// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MIT

import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environment';
import { ReportIssueRequest, ReportIssueResponse } from '@lfx/key-projects/entities/report-issue.entity';

@Injectable({
  providedIn: 'root',
})
export class ReportIssueApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = environment.apiUrl;

  submitReport(payload: ReportIssueRequest): Observable<ReportIssueResponse> {
    return this.http.post<ReportIssueResponse>(`${this.apiUrl}/report-issue`, payload);
  }
}

